export default __webpack_public_path__ + "static/media/45.f4d35c41.png";